import React, { useState, useContext } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Grid, TextField, Typography, Stack } from '@mui/material';
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import appTheme from '../appTheme'
import { ThemeProvider } from '@mui/material/styles'
import EventContext from "../store/event-context";
import { turnDate, displayCapnr, nlStatusFull } from "./helperFunctions";

const ParticipantUpdateModal = ({participant, registerActor, allowResetAllStates, close, resetParticipant, patchParticipant, setShowCapDialog, wavesData }) => {

    const [localParticipant, setLocalParticipant] = useState(participant);
    //const changeNotAllowed = (participant.state === 'done' || participant.state === 'busy' || participant.state === 'ready');
    const changeNotAllowed = (participant.state !== 'initial');     // Changes only before registering
    const eventctx = useContext(EventContext);

    //console.log("Calling ParticipantUpdateModal - participant: ", participant, " - localParticipant: ", localParticipant);

    // Capnr or state was changed, so change local value too
    if (participant.capnr !== localParticipant.capnr || participant.state !== localParticipant.state) {
        setLocalParticipant({
            ...localParticipant,
            'capnr': participant.capnr,
            'state': participant.state
        });
        //setIsWaiting(false);
    }

    // Any other changes
    const changes = Object.keys(localParticipant).filter(item => localParticipant[item] !== participant[item]);

    const handleInputChange = (e) => {
        const { name, value, type, checked} = e.target;
        console.log("Handle change", type, name, value, checked)

        setLocalParticipant({
            ...localParticipant,
            [name]: type === "checkbox" ? checked : 
                name === "birthday" ? turnDate(value) : value,
        });
    };

    const handleChangeCapButton = (e) => {
        //setIsWaiting(true);
        e.stopPropagation();
        e.preventDefault();
        changeCapnrDialog(localParticipant)
    };

    const changeCapnrDialog = async (capnrParticipant) => {
        setShowCapDialog({ capnr: capnrParticipant.capnr, id: capnrParticipant.participantId });
        console.log("After Patching participant")
        //setIsWaiting(false);
    }
   
    const handleClose = () => {  close()  };

    const handleSubmit = async (doCheckinYN) => {
        // Used for both submit changes and/or checkin actor
        //
        console.log("Submit - Changes that will be processed: ", changes);
        //setIsWaiting(true);
        if (changes.length > 0) {
            let loadObj = {};
            changes.forEach(item => loadObj[item] = localParticipant[item]);
            const response = await patchParticipant(localParticipant.participantId, loadObj);
        }
        if (doCheckinYN) {
            console.log("Registring capnr: ", participant.capnr);
            let result = registerActor(participant.capnr);
        }
        //setIsWaiting(false);
        close();
    };

    const handleResetParticipant = () => {
        //setIsWaiting(true);
        resetParticipant(participant.capnr)
    };

    return (
        <ThemeProvider theme={appTheme}>
        <div>
        <Dialog maxWidth='sm' fullWidth open={(participant.capnr.length > 0)} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
        <Stack direction='row' justifyContent='space-between' >
            <Typography align='left' component='span' variant='inherit'>Deelnemergegevens</Typography>
        </Stack>
        </DialogTitle>
        <DialogContent>
            <Box className='participantUpdateModal'>
                <Grid container columns={12}>
                    <Grid item id="Label00" xs={3} sx={{paddingY: 1}}>Capnr.</Grid>
                    <Grid item xs={4} sx={{paddingY: '5px', paddingLeft: '4px'}}>
                        <Typography id="DisplayCapnr" fontWeight='bolder' fontSize='20px' >
                        {displayCapnr(localParticipant.capnr, eventctx.event.colors)}</Typography>
                    </Grid>
                    <Grid item id="CapnrChange" xs={5} sx={{ paddingTop: '4px', paddingBottom: '6px', paddingLeft: 1}} textAlign="right" >
                        <Button id="ChangeCapnrButton" 
                            disabled={localParticipant.state !== "initial"}
                            variant='outlined'
                            sx={{ textTransform: 'capitalize' }}
                            onClick={handleChangeCapButton}
                        >Wijzig capnr.</Button>
                    </Grid>
                    <Grid item id="Label01" xs={3} sx={{paddingY: 1}}>Voornaam</Grid><Grid item xs={9}>
                        <TextField fullWidth
                        id="Input-Firstname"
                        name="firstName"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        required
                        value={localParticipant.firstName}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white'}}
                        />
                    </Grid>
                    <Grid item id="Label02" xs={3} sx={{paddingY: 1}}>Achternaam</Grid><Grid item xs={9}>
                        <TextField fullWidth
                        id="Input-Lastname"
                        name="lastName"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        required
                        value={localParticipant.lastName}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white'}}
                        />
                    </Grid>
                    <Grid item id="Label03" xs={3} sx={{paddingY: 1}} >Postcode</Grid>
                    <Grid item xs={5}>
                        <TextField
                        id="Input-Zipcode"
                        name="zipcode"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        required
                        value={localParticipant.zipcode}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid>
                    <Grid item id="Label04" xs={2} sx={{paddingY: 1, paddingRight: 0.5}} >
                        <Typography textAlign='right' >Huisnr.</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                        id="Input-HouseNumber"
                        name="houseNumber"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        required
                        value={localParticipant.houseNumber}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid>
                  
                    <Grid item id="Label05" xs={3} sx={{paddingTop: 1.2}} >Afstand</Grid>
                     {/*
                    <Grid item id="Input-Distance" xs={9} sx={{paddingTop: '3px', paddingLeft: '4px'}}>

                        <FormControl id="distanceFormControl" component="fieldset" disabled={changeNotAllowed || localParticipant.state !== "initial"}>
                            <RadioGroup id="distanceGroup" row name="distance" value={localParticipant.distance} onChange={handleInputChange}>
                            <FormControlLabel sx={{ marginRight: '20px'}} value="0.5" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>500 m (kids)</Typography>} />
                            <FormControlLabel sx={{ marginRight: '20px'}} value="1" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>1000 m</Typography>} />
                            <FormControlLabel sx={{ marginRight: '20px'}} value="2" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>2000 m</Typography>} />
                            <FormControlLabel value="4" control={<Radio size="small" />} label={<Typography sx={{fontSize: '14px'}}>4000 m</Typography>} />
                            </RadioGroup>
                        </FormControl>
                    
                    </Grid>    
                    */}
                    <Grid item xs={9} >
                        <TextField
                        id="Input-Distance"
                        name="distance"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        required
                        value={localParticipant.distance}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />                        
                    </Grid>
                    <Grid item id="Label06" xs={3} sx={{paddingY: 1}} >Geboortedatum</Grid>
                    <Grid item id="Input-Birthday" xs={9} >
                        <TextField
                        id="Input-Date"
                        name="birthday"
                        type="date"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        required
                        value={localParticipant.birthday ? turnDate(localParticipant.birthday) : ""}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />                        
                    </Grid>
                    <Grid item id="Label07" xs={3} sx={{paddingY: 1}} >Team</Grid>
                    <Grid item xs={9}>
                    	<TextField
                    	id="Input-TeamName"
                    	name="teamName"
                    	type="text"
                    	disabled={changeNotAllowed}
                    	size='small'
                    	variant="outlined"
                    	required
                    	value={localParticipant.teamName}
                    	onChange={handleInputChange}
                    	sx={{ backgroundColor: 'common.white' }}
                    	/>
                    </Grid>
                    <Grid item id="Label08" xs={3} sx={{paddingY: 1}} >Wave</Grid>
                    <Grid item xs={9} >
                        <Select labelId="waves-select"
                        id="Input-Wave"
                        name="wave"
                        disabled={changeNotAllowed}
                        size='small'
                        required
                        onChange={handleInputChange}
                        value={localParticipant.wave}
                        sx={{ backgroundColor: 'common.white', width: '130px'}}
                        >
                          {wavesData.sort((a, b) => a.waveName > b.waveName ? 1 : -1)
                            .map(wave => {return <MenuItem value={wave.waveName} key={wave.waveName}>{wave.waveName}</MenuItem>})}
                        </Select>
                    </Grid>
                    <Grid item id="Label09" xs={3} sx={{paddingY: 1}}>Email</Grid>
                    {participant.email? <Grid item xs={9}>
                        <TextField fullWidth
                        id="Input-email"
                        name="email"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        value={localParticipant.email}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid> : <Grid item xs={9} id="Email-sent" sx={{paddingY: 1}}><Typography>"verzonden"</Typography></Grid>}
                    <Grid item id="Label05" xs={3} sx={{paddingTop: 1.2}} >Telefoonnummer</Grid>
                                         {}
                                        <Grid item xs={9} >
                                            <TextField
                                            id="Input-Phone"
                                            name="phone"
                                            type="text"
                                            disabled={changeNotAllowed}
                                            size='small'
                                            variant="outlined"
                                            required
                                            value={localParticipant.phone}
                                            onChange={handleInputChange}
                                            sx={{ backgroundColor: 'common.white' }}
                                            />
                                        </Grid>
                    <Grid item sx={{paddingY: 2}} xs={7}>
                        {nlStatusFull(participant.state)}
                    </Grid>
                    <Grid item textAlign="right" sx={{paddingTop: '10px'}} xs={5}>
                        {(allowResetAllStates || participant.state === "registered" ) && <Button 
                            variant="outlined"
                            disabled={(participant.state === "initial")}
                            onClick={handleResetParticipant} 
                            sx={{ textTransform: 'none' }} 
                            color="secondary">
                            {(participant.state === 'registered')? 'Aanmelden ongedaan maken': 'Stap terug'}
                        </Button>}
                        {!allowResetAllStates && participant.state === "initial" && <Button 
                            variant="outlined"
                            disabled={false}
                            onClick={(e) => handleSubmit(true) } 
                            sx={{ textTransform: 'capitalize' }} 
                            color="secondary">
                            Aanmelden
                        </Button>}
                    </Grid>
                    <Grid item xs={12} sx={{ paddingTop: 2 }} ><Typography>Contactgegevens in geval van nood</Typography></Grid>
                    <Grid item id="Label10" xs={3} sx={{paddingY: 1, paddingLeft: 2 }} >Voornaam</Grid>
                    <Grid item xs={9}>
                        <TextField fullWidth
                        id="Input-IceFirstName"
                        name="iceFirstName"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        value={localParticipant.iceFirstName}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid>
                    <Grid item id="Label11" xs={3} sx={{paddingY: 1, paddingLeft: 2 }}>Achternaam</Grid>
                    <Grid item xs={9}>
                        <TextField fullWidth
                        id="Input-IceLastName"
                        name="iceLastName"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        value={localParticipant.iceLastName}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid>
                    <Grid item id="Label12" xs={3} sx={{paddingY: 1, paddingLeft: 2 }}>Telefoon 1</Grid>
                    <Grid item xs={3}>
                        <TextField fullWidth
                        id="Input-icePhone1"
                        name="icePhone1"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        value={localParticipant.icePhone1}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid>
                    <Grid item id="Label13" xs={3} sx={{paddingY: 1, paddingRight: 1 }}><Typography textAlign='right' >Telefoon 2</Typography></Grid>
                    <Grid item xs={3}>
                        <TextField fullWidth
                        id="Input-icePhone2"
                        name="icePhone2"
                        type="text"
                        disabled={changeNotAllowed}
                        size='small'
                        variant="outlined"
                        value={localParticipant.icePhone2}
                        onChange={handleInputChange}
                        sx={{ backgroundColor: 'common.white' }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button 
                variant="outlined"
                onClick={handleClose}
                color="secondary"
                sx={{ textTransform: 'capitalize', width: '116px' }}>
            {changes.length > 0? 'Annuleren': 'Sluiten' }
            </Button>
            {!changeNotAllowed && changes.length !== 0 && <Button 
                variant="outlined"
                onClick={(e) => handleSubmit(false)}
                color="primary"
                sx={{ textTransform: 'capitalize', width: '116px' }} >
            Opslaan
            </Button>}
        </DialogActions>
        </Dialog>
        </div>
        </ThemeProvider>
    )
}

export default ParticipantUpdateModal
